/**
 * Landing page for chat.channel.tel.
 *
 * This is what someone visiting `https://chat.channel.tel` directly sees.
 * It's not the embed surface — that's `/chat/:agentId`. This is just a stub
 * page that explains what the host is and links onward.
 */
export function LandingRoute() {
  return (
    <main className="landing">
      <div className="landing__inner">
        <h1>Chanl Chat</h1>
        <p>
          This domain hosts the embeddable Chanl chat widget. It's not meant
          to be visited directly — it's loaded by sites that have installed
          the embed script.
        </p>
        <pre>
          <code>
            {`<script src="https://chat.channel.tel/widget/v1.js"></script>
<script>
  ChanlChat.init({
    agentId: 'ag_xxx',
    apiKey:  'pub_xxx',
  });
</script>`}
          </code>
        </pre>
        <p className="landing__links">
          <a href="https://docs.chanl.ai" target="_blank" rel="noreferrer">
            Documentation
          </a>
          <span aria-hidden="true">·</span>
          <a href="https://chanl.ai" target="_blank" rel="noreferrer">
            chanl.ai
          </a>
        </p>
      </div>
    </main>
  );
}
